import React from 'react';
import { Buffer } from 'buffer';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import { Markdown } from './Markdown';

const decodeBase64 = base64string => {
  try {
    return Buffer.from(base64string, 'base64').toString('utf-8');
  } catch (error) {
    return base64string;
  }
};

const markdownRefinement = markdownText => {
  return markdownText ? markdownText.replace('<sub>', '<sub><br/>') : '';
};

const extractMarkdownText = action => {
  switch (action.action) {
    case 'add-comment@v1':
      return action.args.comment;
    case 'code-review@v1': {
      const codeSuggestions = action.args?.code_suggestions;

      if (codeSuggestions && codeSuggestions.review_message) {
        let markdown = markdownRefinement(codeSuggestions.review_message);

        if (codeSuggestions.code_review_suggestions?.length > 0) {
          // prettier-ignore
          const suggestionsMarkdown = codeSuggestions.code_review_suggestions
            .map(s => `---\n**File:** \`${s.file_path} (${s.start_line}-${s.end_line})\`\n\n${s.comment}`)
            .join('\n\n');
          markdown += `\n\n${suggestionsMarkdown}`;
        }

        return markdown;
      }

      // Fallback to old review field
      return markdownRefinement(action.args.review);
    }
    case 'update-description@v1':
    case 'describe-changes@v1':
      return markdownRefinement(action.args.description);
    case 'explain-code-experts@v1':
      const { comment = '' } = action.args;
      const decodedString = decodeBase64(comment.replace('base64: ', ''));
      return decodedString;
    default:
      return '';
  }
};

const generateMarkdownFromAutomations = automations => {
  return Object.entries(automations || {})
    .filter(([_, automation]) => automation.passed)
    .flatMap(([automationName, automation]) =>
      automation.run
        .map(action => ({
          automationName,
          markdownText: extractMarkdownText(action)
        }))
        .filter(({ markdownText }) => markdownText)
    );
};

const ColoredDivider = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(2, 0),
  textAlign: 'center',
  '&::before, &::after': {
    borderColor: theme.palette.primary.main
  },
  '& .MuiDivider-wrapper': {
    color: theme.palette.primary.main,
    fontWeight: 'bold'
  }
}));

export const AutomationsMarkdown = props => {
  const { gitstreamAutomations } = props;
  const markdownItems = generateMarkdownFromAutomations(gitstreamAutomations);

  return (
    <div>
      {markdownItems.map(({ automationName, markdownText }) => (
        <React.Fragment key={automationName}>
          <ColoredDivider>
            <Typography>{automationName}</Typography>
          </ColoredDivider>
          <Markdown title={automationName} markdownText={markdownText} />
        </React.Fragment>
      ))}
    </div>
  );
};

export default AutomationsMarkdown;
